<template>
  <div
    class="FooterMinimal flex flex-col items-center bg-qwray text-qwraybright text-14px md:text-12px px-8 py-8"
    style="grid-row: var(--footer-row);"
    :class="footerFixed ? 'fixed bottom-0 w-screen' : ''"
    :country="entity"
  >
    <ul class="FooterLinks">
      <li v-for="(link, index) in links" v-bind:key="index">
        <button
          v-if="link.isAction"
          type="button"
          @click="dispatch(link.isAction)"
        >
          {{ $t(link.text) }}
        </button>
        <a v-else-if="link.isExternal" :href="link.ref" target="_blank">{{
          $t(link.text)
        }}</a>
        <router-link v-else :to="{ path: link.ref }">{{
          $t(link.text)
        }}</router-link>
      </li>
    </ul>
    <div class="mt-4 text-center">{{ $t('footer.copyright') }}</div>
  </div>
</template>

<script>
import { entity } from '@/../region.json';
import { minimalFooterLinks } from '@/data/footer';
import { getLinks } from '../shared/entityHelpers';

export default {
  name: 'FooterMinimal',
  props: ['dispatch'],
  data() {
    return {
      entity,
      links: getLinks(minimalFooterLinks, this.$i18n.locale),
    };
  },
  computed: {
    footerFixed() {
      return this.$route.meta.footerFixed;
    },
  },
};
</script>

<style scoped>
.FooterLinks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.FooterLinks li {
  margin: 0 0.75rem;
}
.FooterLinks a,
.FooterLinks button {
  display: block;
  padding: 0.25rem 0;
  color: inherit;
}
.FooterLinks a:hover,
.FooterLinks button:hover {
  color: #ffffff;
}
/* Separators only where the links are certain to fit on one row; a wrapped
   row would otherwise start with a stray divider. */
@media (min-width: 1280px) {
  .FooterLinks li + li {
    border-left: 1px solid #5e7177;
    padding-left: 1.5rem;
  }
}
</style>
